window.addEventListener("load", function () {
    if ($('#nth-ms-event-detail').length > 0  ) {

        if (window.innerWidth <= 768) {
      
            $('html').addClass('fix-mobile');

            setTimeout(() => {
                $('#nth-ms-event-detail .btn-top').css('position', 'fixed');
                $('#nth-ms-event-detail .btn-back').css('position', 'fixed');
            }, 2000);
        }
        
        $('#nth-ms-event-detail .content').on('scroll', function () {
            $('#nth-ms-footer').css('bottom',);
           
            let scrollY = $(this).scrollTop();

            if (scrollY === 0) {

                $('#vxphl-ld-25-a-navigation').show();
                $('#nth-ms-event-detail .news-menu').show();
            } else if (scrollY > 20) {
                $('#vxphl-ld-25-a-navigation').hide();
                $('#nth-ms-event-detail .news-menu').hide();
            }
        });


        $('.btn-top').on('click', function () {
            $('html').animate({ scrollTop: 0 }, 0);
            $('#nth-ms-event-detail .content').animate({ scrollTop: 0 }, 300);
           
        });
    };
   



});